export const NAME = 'cp:loaded'

export default function createEvent() {
    return new CustomEvent(NAME, {
        bubbles: true,
        composed: true,
    })
}
